/**
 * "This section number is already in the project" — Replace / Add as .01 /
 * Cancel. One component for Add Specs and the project .docx import.
 */
import { Button } from '../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../components/ui/dialog';

export type SectionChoice = 'replace' | 'dup';

interface Props {
  open: boolean;
  title: string;
  /** What Replace puts in the old copy's place. */
  incoming: string;
  canAdd: boolean;
  canArchive: boolean;
  onChoose: (choice: SectionChoice) => void;
  onCancel: () => void;
}

export function SectionInProjectDialog({
  open,
  title,
  incoming,
  canAdd,
  canArchive,
  onChoose,
  onCancel,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            This section number is already in the project. Replace archives the current copy
            (restorable) and adds {incoming}.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="items-center justify-between space-x-0">
          <Button
            variant="destructive"
            disabled={!canAdd || !canArchive}
            title={
              !canAdd || !canArchive
                ? 'Replace needs permission to add and to archive project specs'
                : 'Archive the copy in the project and add a fresh one in its place'
            }
            onClick={() => onChoose('replace')}
          >
            Replace
          </Button>
          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="outline" disabled={!canAdd} onClick={() => onChoose('dup')}>
              Add as .01
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
